import { PSYCHOLOGY_QUESTIONS, LIKERT } from "@/data/assessment";
import { cn } from "@/lib/utils";

export default function LikertGroup({ psychology, onChange }) {
  const setValue = (key, val) => onChange({ ...psychology, [key]: val });

  return (
    <div className="space-y-6">
      {PSYCHOLOGY_QUESTIONS.map((q, idx) => (
        <div
          key={q.key}
          className="rounded-xl border border-border p-4 sm:p-5 bg-card"
          data-testid={`likert-row-${q.key}`}
        >
          <div className="flex items-baseline gap-3 mb-3">
            <span className="text-xs font-semibold text-primary tabular-nums">
              {String(idx + 1).padStart(2, "0")}
            </span>
            <p className="text-[15px] font-medium text-foreground">{q.label}</p>
          </div>
          <div className="grid grid-cols-5 gap-2">
            {LIKERT.map((opt) => {
              const active = psychology[q.key] === opt.value;
              return (
                <button
                  key={opt.value}
                  type="button"
                  onClick={() => setValue(q.key, opt.value)}
                  data-testid={`likert-${q.key}-${opt.value}`}
                  className={cn(
                    "py-2 rounded-lg text-xs sm:text-sm font-medium border transition-all",
                    active
                      ? "bg-primary text-primary-foreground border-primary"
                      : "bg-background border-border hover:border-primary/40 hover:bg-accent text-muted-foreground"
                  )}
                >
                  <div className="tabular-nums">{opt.value}</div>
                  <div className="hidden sm:block text-[10px] mt-0.5 opacity-80">
                    {opt.label}
                  </div>
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
